import { Factory } from 'rosie';

Factory.define('MessagingConfiguration');

Factory.define('MessagingConfigurationWithDefaults')
  .extend('MessagingConfiguration')
  .attr('agentCapacity', 4)
  .attr('agentMaxCapacity', 6)
  .attr('assignMailToConversationAssignee', false)
  .attr('autoAssignMessagingSessions', false)
  .attr('endMailSessionIntervalMins', 10)
  .attr('endMessagingSessionIntervalMins', 3)
  .attr('multipleTwitterChannels', false)
  .attr('routeNextMessagingSessionIntervalSecs', 40)
  .attr('showPreview', true);



// WEBPACK FOOTER //
// ./factories/messaging_configuration_factory.js